{
  "fr": {
    "imports": {
      "searchPlaceholder": "Nom...",
      "selectedCount": "aucun élément sélectionné | {count} sélectionné | {count} sélectionnés",
      "cancel": "Annuler",
      "confirm": "Sélectionner",
      "discard": {
        "question": "Annuler la sélection ?",
        "continue": "Continuer à ajouter",
        "confirm": "Annuler"
      },
      "tabWithCount": "{label} ({count})",
      "tabMatches": "{label} : aucun résultat | {label} : {count} résultat | {label} : {count} résultats",
      "contentList": {
        "leaveFolder": "Retour du dossier « {name} »",
        "openFolder": "Ouvrir le dossier « {name} »"
      },
      "loadMore": "Charger plus",
      "submitFailed": "Échec de l'importation. Veuillez réessayer.",
      "toTeach": {
        "modalTitle": "Importer des fiches d'exercices to teach",
        "menuItem": "Importation de to teach",
        "importedBadge": "Importé de to teach",
        "link": {
          "title": "Lier le compte",
          "body": "Votre compte n'est pas encore lié à to teach. Connectez votre compte pour utiliser vos contenus to teach sur fobizz.",
          "confirm": "Accéder à to teach"
        },
        "worksheets": {
          "tabLabel": "Votre compte to teach",
          "accountLink": "Votre compte to teach",
          "searchPlaceholder": "Rechercher des fiches d'exercices to teach",
          "empty": "Aucune fiche d'exercices to teach trouvée.",
          "errorLoading": "Vos fiches d'exercices to teach n'ont pas pu être chargées.",
          "batchQueuedFlash": "Votre fiche d'exercices est importée en arrière-plan. | Votre fiche d'exercices est importée en arrière-plan. | {count} fiches d'exercices sont importées en arrière-plan."
        }
      }
    }
  }
}
